import qrcode from 'qrcode-generator';

/**
 * O QR DESENHADO, e as escolhas que decidem se ele vai ser lido no pátio.
 *
 * ## Correção `H`, e ela não é para enfeite
 *
 * O QR tem quatro níveis de correção de erro; `H` recupera cerca de 30% dos
 * módulos. Num cartão de visita isso é exagero — aqui é o ponto inteiro: o
 * adesivo vive no sol, no barro e no jato de lavagem, e o que ele precisa é
 * continuar legível depois de arranhado. É por isso também que não há logotipo
 * no meio nem módulo colorido: os dois COMEM essa mesma margem, e gastá-la com
 * decoração é trocar a leitura garantida por enfeite. A marca vai na moldura
 * do adesivo, que é onde ela não custa nada.
 *
 * ## Preto sobre branco, e a borda de silêncio
 *
 * A norma exige quatro módulos de margem clara em volta (a "zona de silêncio").
 * Sem ela o leitor não acha o começo do código, e o sintoma é cruel: funciona
 * na tela de quem desenhou, falha no pátio. Ela entra no `viewBox`, então
 * quem usa o desenho não precisa saber que existe.
 *
 * ## Um caminho só, e não setecentos retângulos
 *
 * Um QR deste tamanho tem perto de 1.400 módulos escuros. Como elementos
 * separados, uma folha com 24 adesivos passaria de trinta mil nós — o
 * navegador imprime, mas demora e engasga. Todos viram um `path` só.
 */

/** `H`: recupera ~30% do código. Sol, barro e arranhão entram nessa margem. */
const CORRECAO = 'H';

/** A margem clara que a norma exige, em módulos. */
const SILENCIO = 4;

export interface QrDesenhado {
  /** O `d` de um `<path>`: todos os módulos escuros num caminho só. */
  readonly caminho: string;
  /** O lado do `viewBox`, em módulos, já com a zona de silêncio. */
  readonly lado: number;
  /** Quantos módulos tem o código, sem a margem. Útil para prova. */
  readonly modulos: number;
}

/**
 * O desenho de um conteúdo qualquer. `tipo 0` deixa a biblioteca escolher o
 * menor tamanho que couber — o conteúdo é fixo (esquema, tipo e `id`), mas
 * amarrar um tamanho aqui quebraria no dia em que ele crescer um caractere.
 */
export function desenharQr(conteudo: string): QrDesenhado {
  const qr = qrcode(0, CORRECAO);
  qr.addData(conteudo);
  qr.make();

  const modulos = qr.getModuleCount();
  const partes: string[] = [];
  for (let linha = 0; linha < modulos; linha += 1) {
    /* Módulos escuros VIZINHOS viram um retângulo só. Numa linha cheia isso
       troca 37 comandos por 1, e o caminho cai para perto de um terço. */
    let comeco = -1;
    for (let coluna = 0; coluna <= modulos; coluna += 1) {
      const escuro = coluna < modulos && qr.isDark(linha, coluna);
      if (escuro && comeco === -1) comeco = coluna;
      if (!escuro && comeco !== -1) {
        partes.push(`M${String(comeco + SILENCIO)} ${String(linha + SILENCIO)}h${String(coluna - comeco)}v1h-${String(coluna - comeco)}z`);
        comeco = -1;
      }
    }
  }

  return { caminho: partes.join(''), lado: modulos + SILENCIO * 2, modulos };
}
